var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    fill: "#F2FCF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    stroke: "#01C37D",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_107142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5899 5.82039C22.6932 5.10456 21.5374 4.83873 20.4241 5.09373L14.0049 6.49706L11.8449 5.43123C10.6907 4.86123 9.31073 4.86123 8.15656 5.43123L6.8574 6.07206C5.7124 6.63789 5.00073 7.78289 5.00073 9.05873L4.97656 22.8121C4.97656 24.0454 5.5799 24.5712 5.93906 24.7754C6.12906 24.8821 6.42656 25.0004 6.82323 25.0004C7.20406 25.0004 7.67573 24.8912 8.2299 24.5596L10.0541 23.4229L12.6341 24.6537C13.6007 25.0046 14.6474 25.0912 15.6566 24.9079L21.5791 23.8571C23.5616 23.4971 24.9999 21.7729 24.9999 19.7579V8.75206C24.9999 7.60456 24.4866 6.53623 23.5899 5.82039ZM7.3599 23.1379C6.9899 23.3612 6.79156 23.3446 6.7599 23.3254C6.74156 23.3146 6.6424 23.1812 6.6424 22.8146L6.66656 9.06123C6.66656 8.42206 7.0224 7.84956 7.5949 7.56623L8.89323 6.92539C8.9824 6.88123 9.07406 6.84289 9.16656 6.81039V22.0112L7.35906 23.1379H7.3599ZM10.8341 21.9487V6.81039C10.9274 6.84289 11.0182 6.88123 11.1074 6.92539L13.3341 8.02456V23.1362C13.3149 23.1296 10.8341 21.9487 10.8341 21.9487ZM23.3341 19.7579C23.3341 20.9671 22.4707 22.0012 21.2849 22.2171C21.2849 22.2171 15.1216 23.3046 15.0007 23.3162V7.98456L20.7866 6.71956C21.4082 6.57873 22.0516 6.72539 22.5491 7.12289C23.0482 7.52039 23.3332 8.11373 23.3332 8.75123V19.7562L23.3341 19.7579ZM21.6674 9.36789C21.7657 9.81789 21.4807 10.2621 21.0316 10.3596C21.0316 10.3596 17.5582 11.1112 17.4999 11.1112C17.1166 11.1112 16.7716 10.8454 16.6866 10.4562C16.5882 10.0062 16.8732 9.56206 17.3224 9.46456L20.6749 8.73206C21.1299 8.63289 21.5699 8.91956 21.6674 9.36789ZM21.6674 12.7012C21.7657 13.1512 21.4807 13.5954 21.0316 13.6929C21.0316 13.6929 17.5582 14.4446 17.4999 14.4446C17.1166 14.4446 16.7716 14.1787 16.6866 13.7896C16.5882 13.3396 16.8732 12.8954 17.3224 12.7979L20.6749 12.0654C21.1299 11.9654 21.5699 12.2529 21.6674 12.7012ZM21.6674 16.0346C21.7657 16.4846 21.4807 16.9287 21.0316 17.0262C21.0316 17.0262 17.5582 17.7779 17.4999 17.7779C17.1166 17.7779 16.7716 17.5121 16.6866 17.1229C16.5882 16.6729 16.8732 16.2287 17.3224 16.1312L20.6749 15.3987C21.1299 15.3012 21.5699 15.5862 21.6674 16.0346ZM19.9907 19.7337C20.0891 20.1837 19.8041 20.6279 19.3549 20.7254C19.3549 20.7254 17.5582 21.1112 17.4991 21.1112C17.1157 21.1112 16.7707 20.8454 16.6857 20.4562C16.5874 20.0062 16.8724 19.5621 17.3216 19.4646L18.9982 19.0987C19.4507 18.9996 19.8924 19.2862 19.9899 19.7346L19.9907 19.7337Z",
    fill: "#01C37D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_107142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone3);
export default __webpack_public_path__ + "static/media/megaphone (3).1eab714d6b143bee1d145d745b297dda.svg";
export { ForwardRef as ReactComponent };